import { render, staticRenderFns } from "./CultivarManage.vue?vue&type=template&id=da31b41e&scoped=true"
import script from "./CultivarManage.vue?vue&type=script&lang=js"
export * from "./CultivarManage.vue?vue&type=script&lang=js"
import style0 from "./CultivarManage.vue?vue&type=style&index=0&id=da31b41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da31b41e",
  null
  
)

export default component.exports